﻿import KeyCode from "../utilities/keycode"
import $ from 'jquery';
import _ from "underscore";
import { Url } from "../utilities/url";

declare global {
  interface JQuery {
    photoviewer(option, args): any;
  }
}


export class PhotoViewer {
  public static get wireup(): string { return '[data-photo-viewer]'; }

  private $element: JQuery;
  private photos: Array<Photo>;
  private showing: Photo;
  private $globalOverlay: JQuery;
  private $photosContainer: JQuery;

  public constructor($element: JQuery, options: any) {
    if (!$element || $element.length != 1)
      throw new Error('You must provide an element to Rustig.PhotoViewer');

    this.$element = $element;
    this.buildOverlay();
    this.loadPhotos();
    this.$element.on('click.rustig.photoviewer', '[data-pv-photo]', this.onPhotoClick.bind(this));
    this.setEscapeKeyToClosePhotoViewer();
  }

  public AddPhoto($element: JQuery) {
    if (!$element && $element.length != 1)
      throw Error('You must provide a single element to Rustig.PhotoViewer.AddPhoto');

    this.photos.push(new Photo($element));
  }

  public RemovePhoto($element: JQuery) {
    if (!$element && $element.length != 1)
      throw Error('You must provide a single element to Rustig.PhotoViewer.AddPhoto');

    let photo = this.getPhoto($element);
    this.photos.splice(this.photos.indexOf(photo), 1);
  }

  private buildOverlay(): void {
    this.$globalOverlay = $('#photoViewerGlobalOverlay');
    if (this.$globalOverlay.length <= 0)
      this.$globalOverlay = PhotoViewerGlobalOverlay.build();

    this.$photosContainer = this.$globalOverlay.find('[data-pv-container]');

    this.$globalOverlay.on('close.rustig.photoviewer', this.closeOverlay.bind(this));
    this.$globalOverlay.on('previous.rustig.photoviewer', this.viewPrevious.bind(this));
    this.$globalOverlay.on('next.rustig.photoviewer', this.viewNext.bind(this));
    this.$globalOverlay.on('download.rustig.photoviewer', () => {
      if (this.showing)
        this.showing.downloadPhoto()
    });
  }

  private loadPhotos(): void {
    let self = this;
    self.photos = new Array<Photo>();

    self.$element.find('[data-pv-photo]').each(function () {
      let $this = $(this);

      let photo = self.getPhoto($this);
      if (photo)
        self.photos.push(photo);
      else
        self.photos.push(new Photo($this));
    });
  }

  private setEscapeKeyToClosePhotoViewer(): void {
    $(document).keyup((e) => {
      let isPhotoViewerOpen = this.showing;

      if (isPhotoViewerOpen && e.keyCode == KeyCode.Escape) {
        this.closeOverlay();
        e.stopImmediatePropagation();
      }
    });
  }

  private getPhoto($element: JQuery): Photo {
    let url = $element.data('pv-photo');
    let $photo = this.$globalOverlay.find('pv-full-image'.asDataSelector(url));
    if ($photo.length <= 0)
      return null;
    else
      return $photo.data('rustig.photoviewer.photo');
  }

  public onPhotoClick(event: Event): void {
    let $photo = $(event.target).closest('[data-pv-photo]');
    let url = $photo.data('pv-photo');

    let photo = _.findWhere(this.photos, { downloadUrl: url });
    this.openOverlay(photo);
  }

  private openOverlay(photo: Photo): void {
    this.$globalOverlay.show();
    this.updateShowing(photo);
    $('html').addClass('overflow-hidden');
  }

  private closeOverlay(): void {
    if (!this.showing)
      return;

    this.$globalOverlay.hide();
    this.showing.hide();
    this.showing = null;
    $('html').removeClass('overflow-hidden');
  }

  private viewPrevious(): void {
    if (!this.showing)
      return;

    let index = this.photos.indexOf(this.showing);
    index = index == 0 ? this.photos.length - 1 : index - 1;

    this.updateShowing(this.photos[index]);
  }

  private viewNext(): void {
    if (!this.showing)
      return;

    let index = this.photos.indexOf(this.showing);
    index = index == this.photos.length - 1 ? 0 : index + 1;

    this.updateShowing(this.photos[index]);
  }

  private updateShowing(photo: Photo): void {
    if (this.showing)
      this.showing.hide();

    this.showing = photo;
    this.$photosContainer.append(this.showing.show())
      .trigger('photochanged', { name: this.showing.photoName });
  }
}

function Plugin(option, args) {
  return this.each(function () {
    var $this = $(this);
    var data = $this.data('rustig.photoviewer');
    var options = typeof option == 'object' && option;

    if (!data) {
      data = new PhotoViewer($this, options);
      $this.data('rustig.photoviewer', data);
    }
    if (typeof option == 'string')
      data[option](args);
  });
}

$.fn.photoviewer = Plugin;

class PhotoViewerGlobalOverlay {

  public static build(): JQuery {
    let $root = $('<div>')
      .attr('id', 'photoViewerGlobalOverlay');

    let $grid = $('<div class="grid pv-toolbar">').appendTo($root);

    let $nameContainer = $('<div class="gu-1-2">').appendTo($grid);
    let $name = $('<div class="pv-name" data-bind-to="text">')
      .appendTo($nameContainer);

    let $buttonsContainer = $('<div class="gu-1-2">').appendTo($grid);
    let $tbGroup = $('<div class="tb-group tb-align-right">')
      .appendTo($buttonsContainer);

    let $downloadButton = $('<div class="tb-item"><a title="Download photo"><i class="icon-download icon-sm"></i></a></div>')
      .appendTo($tbGroup)
      .on('click.rustig', () => {
        $root.trigger('download.rustig');
      });

    let $closeButton = $('<div data-pv-close="on" class="tb-item"><a title="Close viewer"><i class="icon-close icon-sm"></i></a></div>')
      .appendTo($tbGroup)
      .on('click.rustig', () => {
        $root.trigger('close.rustig');
      });

    let $photosContainer = $('<div class="pv-full-image-container" data-pv-container="on">')
      .appendTo($root);

    let resizePhotosContainer = () => $photosContainer.height($(window).height() - $grid.height());
    resizePhotosContainer();
    $(window).on('resize.rustig.photoviewer', _.throttle(resizePhotosContainer, 250));

    let $previousButton = $('<div class="pv-previous"><button class="button button-icon" title="View previous photo"><i class="icon-nav-right icon-rotate-180"></i></button></div>')
      .appendTo($photosContainer)
      .on('click.rustig', () => {
        $root.trigger('previous.rustig');
      });

    let $nextButton = $('<div class="pv-next"><button class="button button-icon" title="View next photo"><i class="icon-nav-right"></i></button></div>')
      .appendTo($photosContainer)
      .on('click.rustig', () => {
        $root.trigger('next.rustig');
      });

    return $root.hide()
      .appendTo($(document.body))
      .on('photochanged.rustig', (event, options) => {
        $name.text(options.name);
      });;
  }
}

class Photo {

  private $element: JQuery;
  private $fullImageContainer: JQuery;
  private $image: JQuery;
  private $statusContainer: JQuery;
  private name: string;

  private _downloadUrl: string;
  private downloadAttempted: boolean;

  public get downloadUrl(): string { return this._downloadUrl; }
  public get photoName(): string { return this.name; }

  public constructor($element: JQuery) {
    if (!$element || $element.length != 1)
      throw new Error('You must provide an element to Rustig.Photo');

    this.$element = $element;
    this._downloadUrl = this.$element.data('pv-photo');
    this.name = this.$element.data('pv-photo-name');

    this.$fullImageContainer = $('<div>')
      .attr('data-pv-full-image', this.downloadUrl)
      .addClass('pv-full-image')
      .appendTo(this.$element)
      .data('rustig.photoviewer.photo', this)
      .hide();

    this.$statusContainer = $('<div>')
      .attr('data-pv-status', 'on')
      .addClass('pv-status')
      .html('<i class="icon-lg icon-spinner-cog"></i><br /><span>Downloading</span>')
      .appendTo(this.$fullImageContainer);

    this.$fullImageContainer.data('rustig.photoviewer.photo', this);
  }

  public show(): JQuery {
    if (!this.downloadAttempted) {
      this.downloadForViewer();
      this.downloadAttempted = true;
    }

    return this.$fullImageContainer.show();
  }

  public hide(): void {
    this.$fullImageContainer.hide();
  }

  public downloadPhoto(): void {
    window.open(this.downloadUrl, '_blank');
  }

  private downloadForViewer(): void {
    let urlThatPreventsCaching = new Url(this.downloadUrl)
      .setQueryParameter('time', new Date().getTime().toString())
      .toUrl();
    this.$image = $('<img>')
      .attr('src', urlThatPreventsCaching)
      .appendTo(this.$fullImageContainer)
      .on('load.rustig.photoviewer', this.onSuccess.bind(this))
      .on('error.rustig.photoviewer', this.onError.bind(this));
  }

  private onSuccess(data): void {
    this.$statusContainer.remove();

    let photoSize = PhotoSize.getPhotoSizeScaledToFitContainer(this.$image, this.$image.parent());

    this.$fullImageContainer.css('max-height', photoSize.height);
    this.$fullImageContainer.css('max-width', photoSize.width);
  }

  private onError(): void {
    this.$image.remove();

    let $children = this.$statusContainer.children().hide();
    let $retryContainer = $('<div></div>')
      .append('<div>Error downloading image</div><a data-pv-retry="on">Retry</a>')
      .appendTo(this.$statusContainer)
      .on('click', 'a', () => {
        $retryContainer.remove();
        $children.show();
        this.downloadForViewer();
      });
  }
}

export class PhotoSize {

  constructor(public width: number, public height: number) { }

  public static getPhotoSizeScaledToFitContainer($element: JQuery, $container: JQuery): PhotoSize {
    if (!$element && $element.length != 1 && !$element.is('img'))
      throw Error('You must provide an img element to Rustig.PhotoSize');

    if (!$container && $container.length != 1)
      throw Error('You must provide an container element to Rustig.PhotoSize');

    let image = <HTMLImageElement>$element[0];
    $container = $container || $(<any> window);

    let containerHeight = $container.outerHeight();
    let containerWidth = $container.outerWidth();

    let imageHeight = image.naturalHeight;
    let imageWidth = image.naturalWidth;

    if (imageHeight > containerHeight || imageWidth > containerWidth) {
      let max = imageHeight > imageWidth ? imageHeight : imageWidth;
      let ratio = containerHeight / imageHeight;

      imageHeight = ratio * imageHeight;
      imageWidth = ratio * imageWidth;
    }

    return new PhotoSize(imageWidth, imageHeight);
  }
}
